import { PostModalHeaderSkeleton } from "@circle-react/components/PostsV4/PostModal/PostModalHeaderSkeleton";
import { PostSkeleton } from "@circle-react/components/PostsV4/PostModal/PostSkeleton";
import { useShouldRenderImagePostDetailsModal } from "@circle-react/components/PostsV4/PostModal/useShouldRenderImagePostDetailsModal";
import { Modal } from "@circleco/compass/components/Modal";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";

import { useClosePostModal } from "@/react/hooks/usePostModalNavigation";

import { ImagePostModalSkeleton } from "./ImagePostModalSkeleton";

/** Mirrors `ModalShell`'s loading state while the PostModal chunk loads. */
export const PostModalSkeleton = () => {
  const isMobile = useIsMobile();
  const closePostModal = useClosePostModal();
  const shouldRenderImagePostDetailsModal =
    useShouldRenderImagePostDetailsModal();

  if (shouldRenderImagePostDetailsModal) {
    return <ImagePostModalSkeleton />;
  }

  return (
    <Modal.Root
      open
      size={isMobile ? "full-screen" : "lg"}
      position="top"
      onOpenChange={open => {
        if (!open) closePostModal();
      }}
    >
      <Modal.Content>
        <PostModalHeaderSkeleton />

        <Modal.Body
          scrollFades={false}
          viewportProps={{ style: { scrollbarGutter: "stable" } }}
        >
          <PostSkeleton />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
